export const PAYWALL_WEBVIEW_USER_AGENT_MARKER = 'PaywallWebView/1';
export const PAYWALL_WEBVIEW_MESSAGE_HANDLER_NAMES = [
  'paywallHandler',
  'nativeApp',
  'webview',
  'mobileApp',
  'app',
] as const;

type PaywallWebViewWindow = Window & {
  ReactNativeWebView?: unknown;
  webkit?: {
    messageHandlers?: Record<string, unknown>;
  };
};

export function hasPaywallWebViewUserAgent(userAgent?: string): boolean {
  const actualUserAgent = userAgent
    ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');

  return actualUserAgent.includes(PAYWALL_WEBVIEW_USER_AGENT_MARKER);
}

export function hasPaywallWebViewBridge(targetWindow?: Window): boolean {
  const actualWindow = targetWindow
    ?? (typeof window !== 'undefined' ? window : undefined);

  if (!actualWindow) {
    return false;
  }

  const webViewWindow = actualWindow as PaywallWebViewWindow;
  const messageHandlers = webViewWindow.webkit?.messageHandlers;

  return Boolean(
    webViewWindow.ReactNativeWebView
    || PAYWALL_WEBVIEW_MESSAGE_HANDLER_NAMES.some(
      (handlerName) => messageHandlers?.[handlerName],
    ),
  );
}
